import PropTypes from 'prop-types'
import React from 'react'

import tubeLine from './assets/tube-line.png'
import { Wrapper, LineImg, DynamicImageStyled } from './styles'

const TubeSpit = ({ path }) => {
  return (
    <Wrapper>
      <LineImg alt="" src={tubeLine} />
      <DynamicImageStyled
        image={`${path}tube_spit`}
        imageSizes={{
          xs: 200,
          md: 634,
        }}
        alt="tube spit"
        imageType="png"
      />
    </Wrapper>
  )
}

TubeSpit.propTypes = {
  path: PropTypes.string.isRequired,
}

export default TubeSpit
